<template>
  <el-dialog title="问卷二维码" :visible.sync="visible" width="380px" @closed="handleClose">
    <div>
      <img :src="qrCodeUrl" v-if="qrCodeUrl" style="width: 200px; height: 200px" />
      <div class="mt16 text-center fontC-999 font-S12">微信扫描二维码，此二维码仅供预览题目，不可答题</div>
      <el-button type="info" size="small" class="mt16" @click="downloadQR">下载图片</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'QuestionnaireQRCode',
  data() {
    return {
      visible: false,
      qrCodeUrl: '',
      surveyUrl: '',
      surveyTitle: '',
    };
  },
  methods: {
    open(data) {
      this.visible = true;
      this.surveyUrl = data.surveyUrl;
      this.surveyTitle = data.surveyTitle;
      this.generateQR();
    },
    async generateQR() {
      this.qrCodeUrl = '';
      try {
        this.qrCodeUrl = await QRCode.toDataURL(this.surveyUrl, { width: 200, margin: 2 });
      } catch (e) {
        this.$message.error('生成二维码失败');
      }
    },
    downloadQR() {
      const link = document.createElement('a');
      link.download = `${this.surveyTitle}.png`;
      link.href = this.qrCodeUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  padding-top: 0;
}
</style>
